import React from 'react';

const CampusCard = ({ campus, onDetailsClick }) => {
  const { campusName, location, usersOnboarded, usersOnboardedChangePercent, trendData } = campus;
  
  // Since this is now percentage of total (always positive), we'll always show it as positive
  const changeColor = usersOnboardedChangePercent > 0 ? '#16a34a' : '#94a3b8';
  const changeIcon = usersOnboardedChangePercent > 0 ? 'arrow-upward' : 'remove';
  
  // Generate sparkline points (normalized to 0-100 for SVG)
  const maxValue = Math.max(...trendData.map(d => d.value), 1);
  const minValue = Math.min(...trendData.map(d => d.value), 0);
  const range = maxValue - minValue || 1;
  
  const sparklinePoints = trendData.map((d, i) => {
    const x = (i / Math.max(trendData.length - 1, 1)) * 100;
    const y = 100 - ((d.value - minValue) / range) * 80; // Leave 20% margin at bottom
    return `${x},${y}`;
  }).join(' ');
  
  const locationText = location?.state 
    ? `${location.state}, ${location.country}` 
    : location?.country || 'Unknown';

  return (
    <div 
      className="card border rounded-3 shadow-sm h-100 position-relative"
      style={{
        transition: 'all 0.2s',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = '#f97316';
        e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(249, 115, 22, 0.1), 0 4px 6px -2px rgba(249, 115, 22, 0.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = '';
        e.currentTarget.style.boxShadow = '';
      }}
    >
      <div className="card-body p-4">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div>
            <h3 
              className="mb-1 fw-bold" 
              style={{ 
                fontSize: '1.125rem', 
                color: '#2e1065',
                transition: 'color 0.2s'
              }}
            >
              {campusName}
            </h3>
            <p className="text-muted mb-0 small">{locationText}</p>
          </div>
          <div 
            className="bg-light p-2 rounded"
            style={{ backgroundColor: '#f1f5f9' }}
          >
            <i className="bi bi-three-dots-horizontal text-muted" style={{ fontSize: '1.25rem' }}></i>
          </div>
        </div>

        {/* Users Onboarded */}
        <div className="d-flex align-items-end gap-3 mb-4">
          <span className="fw-black" style={{ fontSize: '3rem', color: '#2e1065', lineHeight: '1' }}>
            {usersOnboarded.toLocaleString()}
          </span>
          <div className="d-flex flex-column mb-1">
            <span className="text-muted small" style={{ fontSize: '0.75rem' }}>Users Onboarded</span>
            <span 
              className="small fw-bold d-flex align-items-center"
              style={{ color: changeColor, fontSize: '0.875rem' }}
            >
              <i className={`bi bi-${changeIcon}`} style={{ fontSize: '0.75rem', marginRight: '2px' }}></i>
              +{usersOnboardedChangePercent.toFixed(1)}% of total
            </span>
          </div>
        </div>

        {/* Sparkline Chart */}
        <div className="mb-4" style={{ height: '48px', position: 'relative' }}>
          <div 
            className="position-absolute bottom-0 start-0 end-0"
            style={{ height: '1px', backgroundColor: '#f1f5f9' }}
          ></div>
          <div 
            className="position-absolute bottom-0 start-0 end-0 rounded-bottom"
            style={{ 
              height: '100%',
              background: `linear-gradient(to top, ${usersOnboardedChangePercent > 0 ? '#f97316' : '#94a3b8'}20, transparent)`
            }}
          ></div>
          <svg 
            className="position-absolute"
            style={{ width: '100%', height: '100%', top: 0, left: 0 }}
            preserveAspectRatio="none"
            viewBox="0 0 100 100"
          >
            <polyline
              fill="none"
              points={sparklinePoints}
              stroke={usersOnboardedChangePercent > 0 ? '#f97316' : '#94a3b8'}
              strokeWidth="2"
              vectorEffect="non-scaling-stroke"
            />
          </svg>
        </div>

        {/* Footer */}
        <div className="d-flex align-items-center justify-content-between pt-3 border-top">
          <div className="d-flex flex-column">
            <span className="text-muted small text-uppercase fw-medium" style={{ fontSize: '0.75rem', letterSpacing: '0.05em' }}>
              Performance
            </span>
            <span className="fw-bold" style={{ color: '#2e1065', fontSize: '1rem' }}>
              {usersOnboardedChangePercent > 0 ? 'Active' : 'Stable'}
            </span>
          </div>
          <button
            className="btn btn-link p-0 text-decoration-none fw-bold"
            style={{ color: '#f97316', fontSize: '0.875rem' }}
            onClick={(e) => {
              e.stopPropagation();
              if (onDetailsClick) {
                onDetailsClick(campus);
              }
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#2e1065';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#f97316';
            }}
          >
            Details <i className="bi bi-arrow-right" style={{ fontSize: '0.75rem' }}></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CampusCard;

